import { fakeBlog, fakeComments } from "../../../../fakes/FBlog";
import { Blog } from "../../../models/Blog";
import { CommentModel } from "../../../models/Comment";
import delayedFunction from "../../../utils/delay";
import IBlogRepository from "../interfaces/IBlogRepository";

class FakeBlogRepository extends IBlogRepository {
    getBlogs: (string: string[]) => Promise<Blog[]> = async () => {
        await delayedFunction(2000);
        return [
            fakeBlog,
        ];
    }
    getBlog: (id: string) => Promise<Blog> = async () => {
        await delayedFunction(2000);
        return fakeBlog;
    }

    getComments: (blogId: string) => Promise<CommentModel[]> = async (blogId: string) => {
        await delayedFunction(2000);
        return fakeComments;
    }

    addComment: (blogId: string, comment: CommentModel) => Promise<CommentModel> = async (blogId: string, comment: CommentModel) => {
        await delayedFunction(2000);
        return comment;
    }

    deleteComment: (commentID: string) => Promise<boolean> = async (commentID: string) => {
        await delayedFunction(2000);
        return true;
    }

    getCategories: () => Promise<string[]> = async () => {
        return ["sample", "categories", "list"];
    }
}

export default FakeBlogRepository;